import { render, staticRenderFns } from "./ReExam.vue?vue&type=template&id=4ed0cac2&scoped=true"
import script from "./ReExam.vue?vue&type=script&lang=js"
export * from "./ReExam.vue?vue&type=script&lang=js"
import style0 from "./ReExam.vue?vue&type=style&index=0&id=4ed0cac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed0cac2",
  null
  
)

export default component.exports